/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Layout from '_Layouts/Layout';
import NotFound from './NotFound';

const title = 'Page Not Found';
const body = <NotFound />;

const action = props => <Layout title={title} body={body} {...props} />;

export default action;
